module.exports = __webpack_public_path__ + "static/media/m-backgroundConfetti.c29279ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guestlist/m-backgroundConfetti.svg
// module id = 2370
// module chunks = 71